import { render, staticRenderFns } from "./CanpayCrewEditConatctPersonDetail.vue?vue&type=template&id=c4dfd0a4&"
import script from "./CanpayCrewEditConatctPersonDetail.vue?vue&type=script&lang=js&"
export * from "./CanpayCrewEditConatctPersonDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports